module.exports = __webpack_public_path__ + "img/C531.40d56629.jpg";